u.Consumer = class extends u.BaseElement {
    attachedCallback() {
        super.attachedCallback();
        this.$storage = null;

        let elem = this.parentElement;
        while (elem) {

            if (elem instanceof u.Storage) {
                this.$storage = elem;
            }
            elem = elem.parentElement;
        }

        if (!this.$storage) {
            throw 'No parent storage element was found';
        }
    };
};

u.ConsumerInput = class extends u.BaseInput {
    attachedCallback() {
        u.Consumer.prototype.attachedCallback.apply(this);
    }
};


u.ConsumerSelect = class extends u.BaseSelect {
    attachedCallback() {
        u.Consumer.prototype.attachedCallback.apply(this);
    }
};

